import { GetBrandCategoryViewModel, GetCategoryBySlugViewModel } from '@/types/api'

import { PLPBasicMetasProps, PLPPages } from '@/app/(plp)/types'

export const createBreadCrumbItems = (page: PLPPages, basicMetas: PLPBasicMetasProps | undefined) => {
    switch (page) {
        case PLPPages.Combination:
            return [
                ...((basicMetas as GetBrandCategoryViewModel)?.category?.breadcrumb || []),
                {
                    nameFa: `${(basicMetas as GetBrandCategoryViewModel)?.category?.breadcrumb?.at(-1)?.nameFa} ${
                        (basicMetas as GetBrandCategoryViewModel)?.brand?.nameFa
                    }`,
                    slug: `${(basicMetas as GetBrandCategoryViewModel)?.category?.breadcrumb?.at(-1)?.slug}`,
                },
            ]
        case PLPPages.Brands:
        case PLPPages.Categories:
        case PLPPages.Search:
        case PLPPages.Tags:
            return (basicMetas as GetCategoryBySlugViewModel)?.breadcrumb
        default:
            return (basicMetas as GetCategoryBySlugViewModel)?.breadcrumb
    }
}
